module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e183"
    }
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151421"
    }
  }, [_vm._v("Copyright © 2009 by Iain Levison ")]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151471"
    }
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151491"
    }
  }, [_vm._v("Published by Soho Press, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151511"
    }
  }, [_vm._v("853 Broadway New York, NY 10003 ")]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151531"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data ")]), _vm._v(" "), _c('div', {
    staticClass: "tx14"
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151551"
    }
  }, [_vm._v("Levison, Iain.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx15"
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151571"
    }
  }, [_vm._v("How to rob an armored car / Iain Levison.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151591"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('div', {
    staticClass: "tx16"
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151611"
    }
  }, [_vm._v("ISBN 978-1-56947-599-7 1. Criminals--Fiction. 2. Pennsylvania--Fiction. I. Title.")])]), _vm._v(" "), _c('div', {
    staticClass: "tx17"
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151631"
    }
  }, [_vm._v("PS3612.E933H69 2009 813'.6--dc22")]), _vm._v(" "), _c('p', {
    staticClass: "jtp2",
    attrs: {
      "id": "d41154789"
    }
  }, [_vm._v("2009011309 ")])]), _vm._v(" "), _c('div', {
    staticClass: "tx18"
  }, [_c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d41151651"
    }
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1 ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2351e05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap4_howtorob_9781569477113_epub_part4.vue
// module id = 69
// module chunks = 0